import styled from 'styled-components';
import { theme } from '../../../constants/theme.mjs';
import '../../Button/index.mjs';
import { Button } from '../../Button/Button.mjs';
"use strict";
const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  row-gap: 16px;
`;
const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Close = styled.div`
  cursor: pointer;

  > div {
    background-color: #50565e !important;
  }
`;
const Heading = styled.h1`
  margin: 0 0 32px;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 0;
  color: #212427;
`;
const LanguageGrid = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 230px;
  grid-template-rows: repeat(8, auto);
  column-gap: 16px;
`;
const CustomLinkButton = styled(Button)`
  line-height: 1;
  display: flex;
  align-items: center;
  height: 28px;
  color: #50565e;

  &:hover {
    color: ${theme.colors.black50};
  }

  ${({
  $active
}) => $active && `
      color: ${theme.colors.primaryBlue};
      background-color: #F9F9FA;
      border-radius: 4px;
  `}
`;
const LanguageValue = styled.div`
  font-family: ${theme.fontFamily.default};
`;
const CustomButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({
  $active
}) => $active && `
      color: ${theme.colors.primaryBlue};
  `}
`;
const Frame = styled.div`
  padding: 16px;
`;
export { ButtonWrap, Close, CustomButton, CustomLinkButton, Frame, Heading, HeadingContainer, LanguageGrid, LanguageValue };
//# sourceMappingURL=LanguageFrame.styles.mjs.map
